import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const GraphContainer = styled.div<{
    withBorder?: boolean;
    onClick?: () => void;
    isLoading?: boolean;
}>`
    box-sizing: border-box;
    padding: ${({ isLoading }) => (isLoading ? "0" : "16px")};
    width: 100%;
    min-width: 190px;
    min-height: 180px;
    position: relative;
    flex-grow: 1;

    ${({ withBorder = true }) =>
        withBorder &&
        css`
            border-right: 1px solid ${colorsPalettes.carbon[50]};
        `};

    ${({ onClick }) =>
        onClick &&
        css`
            cursor: pointer;
        `}

    & .highcharts-container {
        top: -1px;
    }

    @media (min-width: 1440px) {
        min-width: 223px;
    }

    @media (min-width: 1920px) {
        min-width: 206px;
    }
`;

export const MetricHeader = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const MetricTitle = styled.p`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
    margin: 0;
    white-space: nowrap;
`;

export const ValueWrapper = styled.div`
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const MetricValue = styled.p`
    margin: 0 0 4px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const Change = styled.p<{ isIncrease: boolean }>`
    margin: 0;
    ${({ isIncrease }) => setFontVariant("input2", isIncrease ? colorsPalettes.green.s100 : colorsPalettes.red.s100)};
`;

export const EmptyChange = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
`;

export const GranularityIndicator = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
`;

export const PieContainer = styled(FlexRow)`
    justify-content: space-around;
    margin-bottom: 3px;
`;

export const PieValueContainer = styled.div`
    margin-top: 18px;
`;

export const PieValueWrapper = styled.div`
    margin-bottom: 16px;
`;

export const PieValueName = styled.p`
    margin: 0 0 4px;
    ${setFontVariant("queryBar1", colorsPalettes.carbon[500])}
`;

export const PieValue = styled.p`
    margin: 0;
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
`;

export const ChangeWrapper = styled(FlexRow)`
    align-items: center;
    gap: 4px;
`;

export const ChangeValueWrapper = styled(FlexRow)`
    align-items: center;
    justify-content: center;

    .centered {
        text-align: center;
    }
`;

const UniqueIndicator = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
`;

export const Marker = styled.span<{ backgroundColor: string }>`
    flex-shrink: 0;
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
    height: 12px;
    width: 12px;
    margin-right: 8px;
    display: block;
`;

const ValueContainer = styled.div`
    margin-bottom: 8px;
`;

export const LoaderContainer = styled(FlexRow)`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 180px;
    max-height: 180px;
    padding: 0;
`;
